/**
 * @fileoverview Движение борта к waypoint (воздух / земля).
 */

import { H, W } from "../constants/world";
import type { Plane } from "../state/types";
import { angLerp, clamp } from "../util/math";

/**
 * Сдвинуть борт к `(tx, ty)` со скоростью `sp`.
 * @returns `true`, если точка достигнута
 */
export function moveToward(
  p: Plane,
  tx: number,
  ty: number,
  sp: number,
  dt: number,
): boolean {
  const dx = tx - p.x;
  const dy = ty - p.y;
  const d = Math.hypot(dx, dy);
  const ground = sp <= 90;
  const arrive = ground ? 6 : 3.2;

  if (d < arrive) {
    p.x = tx;
    p.y = ty;
    p.v = 0;
    if (ground) {
      p.x = clamp(p.x, 40, W - 40);
      p.y = clamp(p.y, 160, H - 30);
    }
    if (d > 0.01) {
      const want = Math.atan2(dy, dx);
      p.ang = angLerp(p.ang, want, Math.min(1, dt * 8));
    }
    return true;
  }

  const want = Math.atan2(dy, dx);
  if (sp <= 0) {
    p.ang = angLerp(p.ang, want, Math.min(1, dt * 4));
    p.v = 0;
    return false;
  }

  p.ang = angLerp(p.ang, want, Math.min(1, dt * (ground ? 9 : 3.4)));
  const step = Math.min(d, sp * dt);
  if (ground) {
    p.x += (dx / d) * step;
    p.y += (dy / d) * step;
  } else {
    let err = ((want - p.ang + Math.PI * 3) % (Math.PI * 2)) - Math.PI;
    const align = Math.max(0.2, Math.cos(clamp(Math.abs(err), 0, 1.3)));
    p.x += Math.cos(p.ang) * step * align + (dx / d) * step * (1 - align);
    p.y += Math.sin(p.ang) * step * align + (dy / d) * step * (1 - align);
  }
  p.v = sp;
  if (ground) {
    p.x = clamp(p.x, 40, W - 40);
    p.y = clamp(p.y, 160, H - 30);
  }
  return false;
}
